module.exports = __webpack_public_path__ + "img/menu-qd.d65e2127.png";